import { Grid, Box, useMediaQuery, useTheme } from "@mui/material";
import CardGroup from "./Partials/CardGroup";
import Fields from "./Partials/Fields";
import ProductTable from "./Partials/Table/index";
import ScanInsightsChart from "./Partials/InsightChart";

const Dashboard = (): JSX.Element => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <CardGroup />

      <ScanInsightsChart />

      <Box display="flex" flexDirection={lgUp ? "row" : "column"} gap={1}>
        <Fields />
        <ProductTable />
      </Box>
    </Box>
  );
};

export default Dashboard;
